var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DSHeader',{attrs:{"title":"新增问卷"}},[_c('template',{slot:"button"},[_c('div',[_c('a-button',{staticClass:"back-button",attrs:{"type":"primary"},on:{"click":_vm.goBack}},[_vm._v("返回")])],1)])],2),_c('Form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }